import {
  DIARY_FIELD_LIMITS,
  isDiaryEntryEmpty,
  normalizeDiaryEntry
} from '../shared/diaryFields';

export { DIARY_FIELD_LIMITS, isDiaryEntryEmpty, normalizeDiaryEntry };

export const DIARY_WEEK_START_SETTING = 'diary_week_start_day';

export const WEEK_START_OPTIONS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' }
];

export const normalizeWeekStartDay = (value, fallback = 1) => {
  if (value === null || value === undefined || value === '') return fallback;
  const day = Number(value);
  return Number.isInteger(day) && day >= 0 && day <= 6 ? day : fallback;
};

export const DIARY_FIELDS = [
  { key: 'feed', label: 'Feed', placeholder: 'Race mix + vitamins' },
  { key: 'water', label: 'Water', placeholder: 'Emtryl + DoxyMax' },
  { key: 'training', label: 'Training', placeholder: '90 km toss' },
  { key: 'notes', label: 'Notes', placeholder: 'Birds reacted well; droppings were firm' }
];

export const formatDateKey = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const parseDateKey = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
  if (!match) return null;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return formatDateKey(date) === value ? date : null;
};

export const startOfWeek = (value = new Date(), weekStartDay = 1) => {
  const source = value instanceof Date ? value : new Date(value);
  const date = new Date(source.getFullYear(), source.getMonth(), source.getDate());
  const firstDay = normalizeWeekStartDay(weekStartDay);
  const daysSinceStart = (date.getDay() - firstDay + 7) % 7;
  date.setDate(date.getDate() - daysSinceStart);
  return date;
};

export const shiftWeek = (weekStart, amount) => {
  const date = parseDateKey(weekStart) || startOfWeek(weekStart);
  date.setDate(date.getDate() + (amount * 7));
  return formatDateKey(date);
};

export const getWeekDays = (weekStart) => {
  const first = parseDateKey(weekStart) || startOfWeek(weekStart);
  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(first.getFullYear(), first.getMonth(), first.getDate() + index);
    return {
      date,
      key: formatDateKey(date),
      dayName: new Intl.DateTimeFormat(undefined, { weekday: 'long' }).format(date),
      shortDate: new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' }).format(date)
    };
  });
};

export const formatWeekRange = (weekStart) => {
  const days = getWeekDays(weekStart);
  const first = days[0].date;
  const last = days[6].date;
  const sameMonth = first.getMonth() === last.getMonth() && first.getFullYear() === last.getFullYear();
  const sameYear = first.getFullYear() === last.getFullYear();

  if (sameMonth) {
    return `${first.getDate()}–${last.getDate()} ${new Intl.DateTimeFormat(undefined, {
      month: 'long', year: 'numeric'
    }).format(first)}`;
  }

  const firstLabel = new Intl.DateTimeFormat(undefined, {
    day: 'numeric', month: 'short', ...(sameYear ? {} : { year: 'numeric' })
  }).format(first);
  const lastLabel = new Intl.DateTimeFormat(undefined, {
    day: 'numeric', month: 'short', year: 'numeric'
  }).format(last);
  return `${firstLabel} – ${lastLabel}`;
};

export const emptyDiaryEntry = (entryDate) => ({
  entry_date: entryDate,
  feed: '',
  water: '',
  training: '',
  notes: ''
});
